import { DotLabel } from "components/Dot";
import moment from "moment";
import React from "react";
import { formatLongDateWithTime } from "utilities";

interface Props {
  item: server.dto.ExternalCalendarForList | server.dto.ExternalCalendar
}

export const LastRefreshDotLabel = ({ item }: Props) => {
  const lastRefreshedAgo = item.lastRefreshUtc ?
    `${RESX.ExternalCalendar.LastRefresh} ${moment.utc(item.lastRefreshUtc).fromNow()}` :
    RESX.ExternalCalendar.RetrievingData;

  const formattedLastRefreshed = item.lastRefreshUtc ?
    formatLongDateWithTime(item.lastRefreshUtc) :
    RESX.ExternalCalendar.RetrievingData;

  return <span className="s1_gray" title={formattedLastRefreshed}>
    <DotLabel dotColor={item.active ? "green" : "red"}>
      {item.active ?
        <>{lastRefreshedAgo}</> :
        RESX.ExternalCalendar.AutomaticRefreshStopped}
    </DotLabel>
  </span>
}